import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { monitoringReportTranslations as translations } from 'locale/monitoringReports'
import { MonitoringCellData } from '@lmc/ts-common'
import { formatData, popoverReportMappings } from '../../utils'

type ReportingId = keyof typeof popoverReportMappings

type MonitoringReportCellPopoverProps = {
  cellData: MonitoringCellData | undefined
  reportingId: string
}
const MonitoringReportCellPopover = ({
  cellData,
  reportingId,
}: MonitoringReportCellPopoverProps) => {
  const { t } = useTranslation(NAMESPACE.RISK_ASSESSMENT_REPORT)

  const getCellTitle = (cellData: MonitoringCellData) =>
    `${formatData(cellData?.value)} ${
      popoverReportMappings[reportingId as ReportingId]?.title
    }`

  const getCellDescription = (cellData: MonitoringCellData) =>
    `${popoverReportMappings[reportingId as ReportingId]?.description} ${
      cellData?.date
    } `

  // @ts-ignore
  const logNumber = cellData?.logsCount
  const shouldShowLogNumber = logNumber && logNumber !== cellData?.value

  return (
    <Wrapper>
      <TitleText weight="bold">{cellData && getCellTitle(cellData)}</TitleText>
      <DescriptionText weight="regular">
        {cellData && getCellDescription(cellData)}
      </DescriptionText>
      {shouldShowLogNumber && (
        <FooterText level={2} weight="medium">
          {t(translations.TOTAL_COUNT)}
          {` ${logNumber}`}
        </FooterText>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 224px;
  gap: 10px;
`

const TitleText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

const DescriptionText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const FooterText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

export default MonitoringReportCellPopover
